<template>
  <main-content>
    <b-card>
      <ERegistrationCPSRegisterForm :invitation-key="invitationKey"/>
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationCPSRegisterForm from "../components/e-registration-cps-register/ERegistrationCPSRegisterForm";
import { IAmSmartQrCodeApi } from '@/api';

export default {
  props: {
    invitationKey: {
      type: String
    }
  },
  components: {
    ERegistrationCPSRegisterForm
  },

  data() {
    return {
      iamsmartSession: null
    }
  }
};
</script>

<style lang="scss" scoped></style>
